// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1I9fL","header":"PatientQuestionnaire_header__GO0V5","info":"PatientQuestionnaire_info__2g-LT"};